import { getQueryString } from '../../../domain/url-provider';
import { ICompareServersData } from '../interfaces';
import { getHiddenDataString } from '../../../domain/hidden-data-provider';

const COMPARE_SERVERS_STORAGE = 'compare-servers';
export const MAX_ITEMS = 4;
export const COMPARE_SERVERS_EVENT = 'compare-servers-evt';

export const getHiddenData = () : ICompareServersData|null => {
    const strData = getHiddenDataString('compare-servers-data');
    if(!strData) return null;

    try{
        const data = JSON.parse(strData) as ICompareServersData;
        return formatData(data);
    }
    catch (ex){
        return null;
    }
};

export const parseDocumentIDs = (): number[] => {
    const qs = getQueryString()['ids'];
    if(!qs) return [];

    const set: Set<number> = new Set();

    const parts = qs.split('-');
    for(const part of parts){
        const id = Number(part) || 0;
        if(id === 0) continue;
        set.add(id);
    }

    return Array.from(set);
};

export const formatData = (data: ICompareServersData) => {
    if(!data) return data;

    const map: Map<number, Set<number>> = new Map(); // bundle id --> set of plugin IDs
    for(const item of data?.connections){
        const set = map.get(item.bundleDocumentID) || new Set();
        set.add(item.pluginDocumentID);
        map.set(item.bundleDocumentID, set);
    }

    for(const plugin of data.plugins){
        plugin.included = [];

        let lastValue = undefined;
        let isAllSame = true;

        for(const bundle of data.bundles){
            const isIncluded = map.get(bundle.documentID)?.has(plugin.documentID) ?? false;
            plugin.included.push(isIncluded);

            if(lastValue !== undefined && lastValue !== isIncluded){
                isAllSame = false;
            }
            lastValue = isIncluded;
        }

        plugin.isAllIncludedTheSame = isAllSame;
    }

    return data;
};

export const getCompareServersFromStorage = (): number[] => {

    let data: number[] = [];

    try{
        data = JSON.parse(sessionStorage.getItem(COMPARE_SERVERS_STORAGE) || '') || [];
    }
    catch(ex){}

    // remove duplicates ------------
    data = Array.from(new Set(data));

    return data;
};

export const isCompareServersDocumentIdChecked = (documentID: number): boolean => {
    const data = getCompareServersFromStorage();
    const index = data.findIndex(docId => docId === documentID);
    return index !== -1;
};

export const addDocToCompareServers = (documentID: number): number[] => {
    let data = getCompareServersFromStorage();

    data.push(documentID);

    // remove duplicates -----------
    data = Array.from(new Set(data));

    let shouldSendEvent = false;
    if(data.length > MAX_ITEMS) {
        data.shift();
        shouldSendEvent = true;
    }

    sessionStorage.setItem(COMPARE_SERVERS_STORAGE, JSON.stringify(data));

    if(shouldSendEvent){
        document.dispatchEvent(new CustomEvent(COMPARE_SERVERS_EVENT));
    }

    return data;
};

export const removeDocFromCompareServers = (documentID: number): number[] => {
    let data = getCompareServersFromStorage();
    const index = data.findIndex(doc => doc === documentID);
    if(index === -1) return data;

    data.splice(index, 1);

    sessionStorage.setItem(COMPARE_SERVERS_STORAGE, JSON.stringify(data));

    return data;
};

/**
 * https://dev.waves.com/compare-servers?ids=82-29-81-88
 */
export const getCompareServersUrl = () => {
    const data = getCompareServersFromStorage();
    if(data.length <= 0) return '/compare-servers';
    return `/compare-servers?ids=${ data.join('-') }`;
};